/**
 * Created by sungho.hong on 2019-04-19.
 */
export default {
    profile: "",
    session_timestamp_key: "",
    clientId: "ocp-ops2-client",
    portalgate_url: "https://ocp-ops2portalgate-sandbox.dev.opsnow.com",
    myInfoUrl: '',
    init: function(profile) {
        this.profile = profile;
        switch(profile){
            case 'PROD':
                this.session_timestamp_key = "session_timestamp";
                this.portalgate_url = "https://console.opsnow.com" //TODO
                this.myInfoUrl = "https://console.opsnow.com/my_info";
                break;
            case 'DEV':
                this.session_timestamp_key = "session_timestamp_dev";
                this.portalgate_url = "https://ocp-ops2portalgate-sandbox.dev.opsnow.com"
                this.myInfoUrl = "https://ocp-ops2portalgate-sandbox.dev.opsnow.com/my_info";
                break;
            case 'STAGE':
                this.session_timestamp_key = "session_timestamp_stage";
                this.portalgate_url = "https://ocp-ops2portalgate-stage.dev.opsnow.com"
                this.myInfoUrl = "https://ocp-ops2portalgate-stage.dev.opsnow.com/my_info";
                break;
            case "LOCAL":
                this.session_timestamp_key = "session_timestamp_local";
                this.portalgate_url = "https://ocp-ops2portalgate-sandbox.dev.opsnow.com"
                this.myInfoUrl = "https://ocp-ops2portalgate-sandbox.dev.opsnow.com/my_info";
                break;
        }
    },
}



// WEBPACK FOOTER //
// ./src/config/urls.conf.js